<template>
  <a href="#content" class="sr-only left-3 top-3 z-70 focus:not-sr-only focus:absolute">
    <Button as="span" variant="primary">Direct naar inhoud</Button>
  </a>
</template>

<script setup lang="ts">
import { Button } from '@gro-up/ui'
</script>
